import gql from 'graphql-tag'

export const companyToCompanyInvitationAccept = gql`
  mutation companyToCompanyInvitationAccept($token: NonEmptyString!, $email: EmailAddress!) {
    companyToCompanyInvitationAccept(input: { token: $token, email: $email }) {
      success
    }
  }
`
